function IconRotate() {
  return (
    <svg viewBox="0 0 50 50">
      <path d="M32.89,27.48A9.15,9.15,0,0,1,24.17,34h0A9.34,9.34,0,0,1,15,24.5h0A9.34,9.34,0,0,1,24.17,15h0a9.06,9.06,0,0,1,7.93,4.75,6.79,6.79,0,0,1,.85,2m-3.23.67H34V18" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
    </svg>
  );
}

export default IconRotate;
